export default {
  custom_allergen: {
    placeholder: 'Add custom option',
  },
  buttons: {
    add: 'Add',
  },
};
